import SidebarHeaderPreview from './SidebarHeaderPreview';

export default SidebarHeaderPreview;
